import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import "./projectcard.css";

function ProjectCards(props) {
  let a = props.tech.split(" ");
  
  return (
    <Card className="project-card-view">
      <Card.Img
        variant="top"
        width="40px"
        height="200px"
        src={props.imgPath}
        alt="card-img"
      />
      <Card.Body>
        <div className="d-flex flex-column">
          <div className="hgt2">
            <Card.Title>{props.title}</Card.Title>
          </div>

          <div className="hgt mb-2">
            {a.map((tech, i) => {
              return (
                <div>
                  <button className="btnclr">{tech}</button>{" "}
                </div>
              );
            })}
          </div>

          <div>
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>

            {!props.isBlog && props.demoLink && (
              <Button
                variant="primary"
                href={props.demoLink}
                target="_blank"
                style={{ marginLeft: "10px" }}
              >
                <CgWebsite /> &nbsp;
                {"Demo"}
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
